import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export const deleteProcessStep = async ({ id }: { id: string | undefined }): Promise<void> => {
  if (!id) {
    throw new Error("Failed to delete process step");
  }

  const response = await api.processSteps.delete.mutation({
    params: {
      id,
    },
    body: {},
  });

  if (response.status === 204) {
    return;
  }

  throw new ApiError("Failed to delete process step", response.status, response.body);
};
